
export const permissionsNamesSpanish = ['Super Administrador', 'Administrador', 'Gestor', 'Supervisor + acciones', 'Supervisor'];

export const isWriteAvailable = (permissions) => {
    switch (permissions) {
        case 'supervisor':
            return false;
        default:
            return true;
    }
}

export const isUsersManagementAvailable = (permissions) => {
    switch (permissions) {
        case 'supervisor':
            return false;
        case 'manager':
            return false;
        default:
            return true;
    }
}

export const areAdvanceOptionsAvailable = (permissions) => {
    switch (permissions) {
        case 'super_administrator':
            return true;
        default:
            return false;
    }
}

export const permissionsValuesToNames = (permissions) => {
    switch (permissions) {
        case 'super_administrator':
            return 'Super Administrador';
        case 'administrator':
            return 'Administrador';
        case 'manager':
            return 'Gestor';
        case 'actions_supervisor':
            return 'Supervisor + actuaciones';
        case 'supervisor':
            return 'Supervisor';
        default:
            return 'Supervisor';
    }
}
export const permissionsToInteger = (permissions) => {
    switch (permissions) {
        case 'super_administrator':
            return 0;
        case 'administrator':
            return 1;
        case 'manager':
            return 2;
        case 'actions_supervisor':
            return 3;
        case 'supervisor':
            return 4;
        default:
            return 4;
    }
}

export const integerToPermissions = (permissions) => {
    switch (permissions) {
        case 0:
            return 'super_administrator';
        case 1:
            return 'administrator';
        case 2:
            return 'manager';
        case 3:
            return 'actions_supervisor';
        case 4:
            return 'supervisor';
        default:
            return 'supervisor';
    }
}
export const permissionsMarks = [
    {
        value: 0,
        label: 'super_administrator',
    },
    {
        value: 1,
        label: 'administrator',
    },
    {
        value: 2,
        label: 'manager',
    },
    {
        value: 3,
        label: 'supervisor',
    },
];